module.exports = __webpack_public_path__ + "b721b6c642a54612f1debfe4b041c2cd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/blue_cured.png
 ** module id = 996
 ** module chunks = 0
 **/